module.exports = "/_next/static/images/recommendations_mobile-2b9b4d6127d7f8df9872c74be134f888.jpg";